import Vue from 'vue'

export default Vue.component(
  'primary-nav',
  {
    data () {
      return {
        isMobileNavOpen: false,
        isUserMenuOpen: false
      }
    },
    methods: {
      toggleMobileNav: function (e) {
        e.preventDefault()
        e.stopPropagation()
        this.isMobileNavOpen = !this.isMobileNavOpen

        // Close menu on click outside element:
        if (this.isMobileNavOpen) {
          document.addEventListener('click', this.checkClickInside)
        }
      },
      toggleUserMenu: function (e) {
        e.preventDefault()
        e.stopPropagation()
        this.isUserMenuOpen = !this.isUserMenuOpen

        // Close menu on click outside element:
        if (this.isUserMenuOpen) {
          document.addEventListener('click', this.checkClickInside)
        }
      },
      checkClickInside: function (e) {
        var openMenuName = this.isUserMenuOpen ? 'user-menu' : 'mob-nav'
        var openMenu = document.getElementById(openMenuName)

        if (!!openMenu && !openMenu.contains(e.target)) {
          if (openMenuName === 'user-menu') {
            this.isUserMenuOpen = false
          } else {
            this.isMobileNavOpen = false
          }
          document.removeEventListener('click', this)
        }
      }
    }
  }
)
